/* eslint-disable react/jsx-no-bind */
import { Link, useLocation } from 'react-router-dom';
import * as React from 'react';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';
import { UitkCard, UitkCardContentSection, UitkCardLink } from 'uitk-react-cards';
import { UitkCarousel } from 'uitk-react-carousel';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLink } from 'uitk-react-link';
import { parse } from 'query-string';
import { EgdsHeadingTagStyle } from '../../../../constants';
import { useStores } from '../../../../utils/hooks/useStores';
import { getSeeAllURL } from '../../../../helpers/common-helper';
import { onClickScrollToTarget } from '../../../../helpers/smooth-scroll';
export var SlimCategoryCarousel = function (_a) {
  var categoryGroup = _a.categoryGroup;
  var _b = useStores(),
    analytics = _b.analytics,
    activitySearchStore = _b.activitySearchStore;
  var location = useLocation();
  var queryParams = parse(location.search);
  var handleAnalytics = function (categoryAnalytics, isCategoryAction
  // eslint-disable-next-line consistent-return
  ) {
    activitySearchStore.searchSetup();
    if (!categoryAnalytics) {
      return null;
    }
    if (isCategoryAction) {
      onClickScrollToTarget({
        scrollTo: 0
      });
    }
    analytics.trackEvent(categoryAnalytics.referrerId, categoryAnalytics.linkName, analytics.omnitureData);
  };
  var renderCategoryCard = function (category, index) {
    var _a, _b;
    var primary = category.primary;
    if (!primary.text) {
      return null;
    }
    var disabledClass = category.enabled === false ? 'disabled-card' : '';
    return React.createElement(UitkCard, {
      key: "slim-category-carousel-card-".concat(index),
      "data-testid": "slim-category-carousel-card-".concat(index),
      tag: "li",
      border: true
    }, React.createElement(UitkLayoutFlex, {
      direction: "column",
      justifyContent: "space-between",
      className: "slim-category-details"
    }, React.createElement(UitkCardContentSection, {
      "data-testid": "slim-category-carousel-content-name-".concat(index),
      className: disabledClass,
      padded: ['inlineend', 'inlinestart', 'blockstart']
    }, React.createElement(IntersectionTracker, {
      referrerId: "".concat((_a = category.clientSideAnalytics) === null || _a === void 0 ? void 0 : _a.referrerId, ".carousel.view.impression"),
      linkName: ((_b = category.clientSideAnalytics) === null || _b === void 0 ? void 0 : _b.linkName) || 'Category carousel view impression',
      trackOnce: true,
      intersectionOptions: {
        threshold: 1.0
      }
    }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkHeading, {
      tag: primary.headingType ? EgdsHeadingTagStyle[primary.headingType] : 'h3',
      size: 7,
      className: "uitk-type-300 type-gray truncate-lines-2"
    }, primary.text)))), React.createElement(UitkCardContentSection, {
      "data-testid": "slim-category-carousel-content-secondary-".concat(index),
      className: disabledClass,
      padded: ['inlineend', 'inlinestart', 'blockend']
    }, category.secondaryMessage ? React.createElement(UitkText, {
      size: 300,
      className: "uitk-type-200 uitk-type-regular truncate"
    }, category.secondaryMessage) : null)), React.createElement(UitkCardLink, null, category.enabled ? React.createElement(Link, {
      onClick: handleAnalytics.bind(null, category.clientSideAnalytics, true),
      to: getSeeAllURL(category.link, queryParams)
    }, primary.text) : React.createElement(React.Fragment, null)));
  };
  var renderShowAllThingsToDoLink = function (action) {
    return React.createElement(UitkLink, {
      "data-testid": "slim-category-carousel-show-all-things-to-do--link"
    }, React.createElement(Link, {
      to: action.url,
      onClick: handleAnalytics.bind(null, action.analytics, false)
    }, action.label));
  };
  var activityTiles = categoryGroup.activityTiles,
    action = categoryGroup.action;
  var CategoryCarousel = function (classname) {
    return React.createElement("section", {
      id: "slim-category-list",
      className: classname,
      "data-testid": "slim-category-carousel--section"
    }, React.createElement(UitkCarousel, {
      carouselName: "slim-category-carousel",
      itemsVisible: {
        lg: 6,
        md: 5,
        sm: 2
      },
      pageBy: 1,
      buttonText: {
        nextButton: 'next',
        prevButton: 'previous'
      },
      navigationIconId: {
        next: 'slim-category-carousel-next-button-title',
        prev: 'slim-category-carousel-prev-button-title'
      },
      wrapItems: true,
      itemsMaxHeight: true,
      peek: true
    }, activityTiles.map(function (category, index) {
      return renderCategoryCard(category, index);
    })), action && renderShowAllThingsToDoLink(action));
  };
  return activityTiles && activityTiles.length > 0 ? React.createElement(Viewport, null, React.createElement(ViewLarge, null, CategoryCarousel('slim-category-carousel-desktop')), React.createElement(ViewSmall, null, CategoryCarousel('slim-category-carousel-mobile'))) : null;
};